import React from 'react';
import { Home, Leaf, ShoppingBag, Settings, CheckCircle } from 'lucide-react';
interface NavItemProps {
  icon: React.ElementType;
  label: string;
  active?: boolean;
  onClick?: () => void;
}
function NavItem({
  icon: Icon,
  label,
  active = false,
  onClick
}: NavItemProps) {
  return <button onClick={onClick} className="flex flex-col items-center gap-1 py-2 px-3 transition-colors group" data-id="element-17">
      <Icon className={`h-6 w-6 transition-colors ${active ? 'text-green-600' : 'text-gray-400 group-hover:text-gray-600'}`} strokeWidth={1.5} data-id="element-18" />
      <span className={`text-xs font-medium transition-colors ${active ? 'text-green-600' : 'text-gray-400 group-hover:text-gray-600'}`} data-id="element-19">
        {label}
      </span>
    </button>;
}
interface BottomNavProps {
  activePage?: string;
  onNavigate?: (page: string) => void;
}
export function BottomNav({
  activePage = 'home',
  onNavigate
}: BottomNavProps) {
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 pb-safe pt-1 px-4 z-50" data-id="element-20">
      <div className="flex justify-between items-center max-w-md mx-auto" data-id="element-21">
        <NavItem icon={Home} label="Home" active={activePage === 'home'} onClick={() => onNavigate?.('home')} data-id="element-22" />
        <NavItem icon={Leaf} label="Azioni" active={activePage === 'impact'} onClick={() => onNavigate?.('impact')} data-id="element-23" />
        <NavItem icon={CheckCircle} label="Attività" active={activePage === 'actions'} onClick={() => onNavigate?.('actions')} data-id="element-24" />
        <NavItem icon={ShoppingBag} label="Premi" active={activePage === 'market'} onClick={() => onNavigate?.('market')} data-id="element-25" />
        <NavItem icon={Settings} label="Impostazioni" active={activePage === 'settings'} onClick={() => onNavigate?.('settings')} data-id="element-26" />
      </div>
    </div>;
}